export default __webpack_public_path__ + "static/media/dozule13.df61ccb3.jpg";